

















import { Component, Vue, Prop } from "vue-property-decorator";
import { List } from 'vant';
import { ErrorCode, ErrorInfo } from "@/network/http";
import { formatMessage } from "@/locale";
import { FaqInfo, FaqList } from  "@/data/local/faq";
import FaqItem from "@/components/FaqItem.vue";

Vue.use(List);

@Component({
    components: {
        "v-faq-item": FaqItem
    }
})
export default class FaqListView extends Vue {
    @Prop(Number)
    cityId: number;
    @Prop(Number)
    cat: number;

    pageNo: number = 1;
    pageSize: number = process.env.VUE_APP_DEFAULT_PAGE_SIZE;
    immCheck: boolean = false;
    listLoading: boolean = false;
    listFinished: boolean = false;
    listLoadError: boolean = false;
    listLoadingText: string = formatMessage({id: "message.common.loading"});
    finishText: string = formatMessage({id: "message.common.listNoMore"});
    listErrorText: string = formatMessage({id: "message.common.listError"});

    listData: FaqInfo[] = [];

    
    keyword: string = "";

    mounted() {
        this.listData = [];
        this.pageNo = 1;
        this.fetchList();
    }

    fetchList(): void {
        this.listLoading = true;
        this.listLoadError = false;

        let lThis:any = this;
        lThis.$http.getFaqList(this.keyword, this.cityId, 1, this.cat, this.pageNo, this.pageSize, (errorInfo: ErrorInfo, data: FaqList) => {
            if (errorInfo.errorCode !== ErrorCode.SUCCESS) {
                this.listLoadError = true;
            } else {
                data && data.list.forEach((item: FaqInfo) => {
                    // 去重 
                    let exist: boolean = false;
                    for (let n = 0; n < this.listData.length; n++) {
                        if (this.listData[n].id === item.id) {
                            exist = true;
                            break;
                        }
                    }

                    if (!exist) {
                        this.listData.push(item);
                    }
                });

                this.pageNo = this.pageNo + 1;

                if (data && this.pageNo > data.pagination.totalPage) {
                    this.listFinished = true;
                }
            }

            this.listLoading = false;
        });
    }

    onClickItem(item: FaqInfo): void {
        this.$router.push({path: "/fund/faq/detail/" + item.id});
    }
}
